import React from "react";
import { TitleBar, FeedbackForm } from "webapp/components";
import "./Feedback.scss";
import { useTranslation } from "react-i18next";
import logoIcon from "assets/logo/TrxNow_Logo_Alt_White_H.png";
import questionIcon from "assets/ui-img/questionMarkWhiteCircleBg2x.png";
import { useState } from "react";
import CallbackForm from "webapp/components/CallbackForm/CallbackForm";
import { useEffect } from "react";

export default function Feedback(props) {
  const { t } = useTranslation();

  const [isNT, setIsNT] = useState(false);
  const [isOverrideNT, setIsOverrideNT] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setIsNT(searchParams.has("nt") && parseInt(searchParams.get("nt")) === 1);
  }, []);

  const feedback = {
    img: props.logo,
    fragment: (
      <React.Fragment>
        <p className="mb-0">
          <strong>{t("description.FeedbackTitleBar1")}</strong>
          <br />
          <span style={{ color: "#999" }}>
            {t("description.FeedbackTitleBar2")}
          </span>
        </p>
      </React.Fragment>
    ),
  };
  const feedback2 = {
    img: questionIcon,
    fragment: (
      <React.Fragment>
        <p>
          {!isNT || (isNT && isOverrideNT)
            ? t("description.FeedbackSubHeader")
            : t("description.FeedbackSubHeaderAlt")}
        </p>
      </React.Fragment>
    ),
  };

  const onOverrideNT = () => {
    setIsOverrideNT(true);
  };

  return (
    <div className="feedback">
      <TitleBar data={feedback} />
      <div className="titleBarContainer2">
        <img className="img" src={feedback2.img} alt="trx now logo" />
        <div className="text">{feedback2.fragment}</div>
      </div>
      {isNT && !isOverrideNT ? (
        <CallbackForm currState={props.currState} onYes={onOverrideNT} />
      ) : (
        <FeedbackForm
          callBackFunc={props.callBackFunc}
          currState={props.currState}
        />
      )}
    </div>
  );
}
